import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGroup } from 'reactstrap';
import { useIntl } from 'react-intl';

import { formatSettings } from '../../../helpers/DateTime';

import ErrorBoundary from '../../ErrorBoundary';
import SettingsItemBoolean from '../Settings/Item/ItemBoolean';
import SettingsItemSelect from '../Settings/Item/ItemSelect';

const AdminUserEditUserSettings = ({
  settings,
  isSelfEdit,
  handleChange,
}) => {
  const intl = useIntl();

  return (
    <ErrorBoundary>
      <div className="switch-list">
        {Object.keys(formatSettings(settings, isSelfEdit, intl)).map((key) => {
          const setting = settings[key];

          if (setting.hidden) {
            return null;
          }

          return (
            <FormGroup key={`setting-${key}`}>
              {setting.type === 'boolean' && (
                <SettingsItemBoolean
                  settingKey={key}
                  setting={setting}
                  disabled={setting.gated}
                  handleChange={handleChange}
                />
              )}
              {setting.type === 'select' && (
                <SettingsItemSelect
                  settingKey={key}
                  setting={setting}
                  disabled={setting.gated}
                  handleChange={handleChange}
                />
              )}
            </FormGroup>
          );
        })}
      </div>
    </ErrorBoundary>
  );
};

AdminUserEditUserSettings.propTypes = {
  settings: PropTypes.object.isRequired,
  isSelfEdit: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default connect()(AdminUserEditUserSettings);
